// @ts-strict-ignore
import React, { useContext, useMemo } from 'react';
import { parse } from 'query-string';
import { useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Text,
  ButtonVariant,
  Icon,
  IconName,
} from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import { StyledButton, StyledLink } from './styles';
import STATUS_CODES from './constants';
import { routes } from '~/helpers/routes';

interface ErrorStatusViewProps {
  embedded?: boolean;
  status?: string;
  statusCode?: number;
  message?: string;
}

const ErrorStatusView: React.FC<ErrorStatusViewProps> = ({
  embedded = false,
  status: customStatus,
  statusCode: customStatusCode,
  message: customMessage,
}) => {
  const location = useLocation();
  const { agent } = useContext(UserContext);

  const urlParams = useMemo(() => (parse(location.search)), [location]);

  const fromAdmin = useMemo(() => {
    if (window.history?.state?.from) {
      return window.history.state.from.split('/').includes('admin');
    }
    return agent?.isEmployee;
  }, [agent]);

  const { statusCode = customStatusCode } = useParams();
  const status = customStatus ?? (STATUS_CODES[statusCode] || 'Error');
  const message = customMessage ?? "This page isn't working right now";
  const homeHref = fromAdmin
    ? routes.v3.dashboard.admin.customers.list
    : routes.v3.dashboard.home.dashboard;
  const margin = embedded ? '0 0 0 var(--cl-space-6)' : '80px 0 0 110px';
  return (
    <Box direction="column" alignItems="flex-start" gap={6} style={{ margin }}>
      {STATUS_CODES[statusCode] && <Text as="h1" size={6} weight={500}>{statusCode}</Text>}
      <Text as="h1" size={6} weight={500}>{status}</Text>
      {status === STATUS_CODES['404']
        ? (
          <Text weight={400}>The page you were looking for could not be found.{' '}
            ({urlParams?.linkUrl})
          </Text>
        )
        : <Text weight={400} style={{ color: 'var(--cl-gray-700)' }}>{message}</Text>}
      <Box direction="column" alignItems="flex-start">
        <StyledLink data-testid="go-home-link" href={homeHref}>
          <StyledButton variant={ButtonVariant.tertiary}>
            <span>Go Home</span>
            <Icon icon={IconName.ArrowRight} />
          </StyledButton>
        </StyledLink>
        <Text weight={400} style={{ color: 'var(--cl-gray-700)' }}>Return to the home page</Text>
      </Box>
    </Box>
  );
};

export default ErrorStatusView;
